import { PropsWithChildren, ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import { Tooltip } from 'antd';

import { Path } from 'enums';

import styles from './MenuItem.module.scss';

interface IProps {
  readonly icon: ReactNode;
  readonly text: string;
  readonly path: Path;
  readonly collapsed: boolean;
  readonly isActiveLink?: boolean;
}

export const MenuLink = ({ icon, text, path, collapsed, children, isActiveLink }: PropsWithChildren<IProps>) => {
  const getNavLinkClassName = ({ isActive }: { isActive: boolean }) =>
    classNames(styles.navigationItem, styles.menuLink, {
      [styles.active]: isActiveLink || isActive,
      [styles.compact]: collapsed,
    });

  return (
    <Tooltip title={collapsed ? text : null} placement="right">
      {/* wrap with div because Tooltip breaks NavLink.className logic */}
      <div>
        <NavLink to={path} aria-label={text} className={getNavLinkClassName}>
          <div className={styles.iconContainer}>
            {icon}
            <span className={styles.text}>{text}</span>
          </div>
          {children}
        </NavLink>
      </div>
    </Tooltip>
  );
};
